import { render, staticRenderFns } from "./ProductAddPopup.vue?vue&type=template&id=1d7145d1&scoped=true&"
import script from "./ProductAddPopup.vue?vue&type=script&lang=js&"
export * from "./ProductAddPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddPopup.vue?vue&type=style&index=0&id=1d7145d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7145d1",
  null
  
)

export default component.exports